import { type WaterSource } from "@/types/water-source";

export function WaterSource({
	waterSource,
	fallback,
	className,
}: {
	waterSource?: WaterSource;
	fallback?: string;
	className?: string;
}) {
	if (!waterSource) return <div className={className}>{fallback}</div>;

	const sources = [];
	if (waterSource.supply === "yes") sources.push("Supply (Cauvery)");
	if (waterSource.borewell === "yes") sources.push("Borewell");
	if (waterSource.tanker === "yes") sources.push("Tanker");

	if (!sources.length) return null;

	return <div className={className}>{sources.join(", ")}</div>;
}
